import type { ReactElement } from "react";
import { useRef } from "react";

import { CSSTransition } from "react-transition-group";
import type { CSSTransitionProps } from "react-transition-group/CSSTransition";

import { FadeContainer } from "./styles";

type ColumnOptionFadeTransition = Omit<CSSTransitionProps, "addEndListener"> & {
    children: ReactElement;
};

export const ColumnOptionFadeTransition = (props: ColumnOptionFadeTransition) => {
    const nodeRef = useRef(null);

    return (
        <CSSTransition
            timeout={300}
            classNames="fade"
            {...props}
            nodeRef={nodeRef}
        >
            <FadeContainer ref={nodeRef}>{props.children}</FadeContainer>
        </CSSTransition>
    );
};
